import React, { useState } from 'react';
import { Box, List, ListItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { Link } from 'react-router-dom';
import SearchComponent from './SearchComponent';
import Logo from './pictures/frame-logo.png';

const DrawerMenu = ({ data, closeDrawer }) => {
  const [clickedMenuItem, setClickedMenuItem] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState({});
  const [searchOpen, setSearchOpen] = useState(false);

  const handleMenuClick = (menu) => {
    setClickedMenuItem(menu);
    setSubmenuOpen((prevState) => ({
      ...prevState,
      [menu]: !prevState[menu],
    }));
  };

  const handleSearchBar = () => {
    setSearchOpen(!searchOpen);
  };

  const isExternalLink = (url) => /^https?:\/\//.test(url);

  const renderSubMenu = (items, level = 1) => {
    return (
      <Box className="bg-topAlmond rounded-[20px]">
        {items.map((item, index) => (
          <ListItem key={index} className="flex flex-col">
            <div className="list-none flex items-center justify-between w-full ">
              {isExternalLink(item.path) ? (
                <a
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${clickedMenuItem === item.label ? 'text-topGreen' : 'text-SlateGray'
                    } font-semibold font-manrope text-[16px] text-left leading-[24px] cursor-pointer hover:text-topGreen pb-3`}
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  to={item.path || '#'}
                  className={`${clickedMenuItem === item.label ? 'text-topGreen' : 'text-SlateGray'
                    } font-semibold font-manrope text-[16px] text-left leading-[24px] cursor-pointer hover:text-topGreen pb-3`}
                  onClick={() => handleMenuClick(item.label)}
                >
                  {item.label}
                </Link>
              )}

              {item.items && item.items.length > 0 && (
                <span onClick={() => handleMenuClick(item.label)}>
                  <svg
                    className={`${submenuOpen[item.label] ? 'transform rotate-90' : ''} transition-transform duration-200 ease-in-out`}
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M4.5 3L7.5 6L4.5 9"
                      stroke={clickedMenuItem === item.label ? '#34D399' : '#6B7280'}
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              )}
            </div>

            {submenuOpen[item.label] && item.items && item.items.length > 0 && (
              <Box className="pl-[16px]  mt-2">
                {renderSubMenu(item.items, level + 1)}
              </Box>
            )}
          </ListItem>
        ))}
      </Box>
    );
  };

  const drawer = (
    <Box
      sx={{
        width: { xs: '100vw', sm: '100vw', md: 250 },
        bgcolor: 'background.paper',
        overflowY: 'auto',
        maxHeight: '100vh',
      }}
    >
      <Box className="flex flex-row justify-between ml-5 pt-2 pb-3">
        <Box>
          <Link to="/">
            <img src={Logo} alt="Logo" className="w-9 h-11" />
          </Link>
        </Box>

        <Box
          onClick={closeDrawer}
          className="flex justify-center items-center rounded-full border border-customBlack mr-[10px] hover:bg-customBlack w-10 h-10"
        >
          <CloseIcon style={{ color: '#0F6742', width: '30px' }} />
        </Box>
      </Box>

      <List>
        {Object.keys(data).map((sectionKey) => {
          const section = data[sectionKey];
          return (
            <React.Fragment key={sectionKey}>
              <ListItem>
                <div className="list-none flex items-center justify-between w-full">
                  {isExternalLink(section.url) ? (
                    <a
                      href={section.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`${clickedMenuItem === section.title ? 'text-topGreen' : 'text-SlateGray'}
                        font-semibold font-manrope text-[16px] text-left leading-[24px]
                        cursor-pointer hover:text-topGreen pb-3`}
                    >
                      {section.title}
                    </a>
                  ) : (
                    <Link
                      to={section.url || '#'}
                      onClick={() => handleMenuClick(section.title)}
                      className={`${clickedMenuItem === section.title ? 'text-topGreen' : 'text-SlateGray'}
                        font-semibold font-manrope text-[16px] text-left leading-[24px]
                        cursor-pointer hover:text-topGreen pb-3`}
                    >
                      {section.title}
                    </Link>
                  )}

                  {section.links && section.links.length > 0 && (
                    <span onClick={() => handleMenuClick(section.title)}>
                      <svg
                        className={`${submenuOpen[section.title] ? 'transform rotate-90' : ''
                          } transition-transform duration-200 ease-in-out`}
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M4.5 3L7.5 6L4.5 9"
                          stroke={clickedMenuItem === section.title ? '#34D399' : '#6B7280'}
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  )}
                </div>
              </ListItem>

              {submenuOpen[section.title] && section.links && section.links.length > 0 && (
                <Box className="pl-4 pr-4 mt-2">{renderSubMenu(section.links)}</Box>
              )}
            </React.Fragment>
          );
        })}

      </List>

      
        <Box className="lg:hidden z-100">
          <SearchComponent closeSearchBar={handleSearchBar} />
        </Box>
      
    </Box>
  );

  return drawer;
};

export default DrawerMenu;
